import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './ThreadOrderSelect';
import { getThreadState } from '../../selectors';
import { changeOrder } from '../../actionCreators';
import { ThreadOrder } from '../../types';

export type StateProps = Pick<Props, 'order' | 'streamId'>;
export type DispatchProps = Pick<Props, 'onOrderChangedDefault'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const VALID_ORDERS: ThreadOrder[] = ['newest', 'oldest'];

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (
  state,
  { commentableItemId, commentableTypeId, parentId }
) => {
  const { streamId, order } = getThreadState(
    state,
    commentableTypeId,
    commentableItemId,
    parentId
  );

  const validOrder: ThreadOrder =
    order && VALID_ORDERS.includes(order) ? order : 'newest';

  return {
    streamId,
    order: validOrder,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  onOrderChangedDefault: changeOrder,
};

export default connect(mapStateToProps, mapDispatchToProps);
